import React from "react";
import { useSelector } from "react-redux";
import { getSelectedAction } from "../store/workspaceSlice";
import { headings } from "../helpers";
import FileSettingPage from "../pages/FileSettingPage";
import GroupbyFeaturePage from "../pages/GroupbyFeaturePage";
import AddCharactersPage from "../pages/AddCharactersPage";
import DisplayStartMsg from "./DisplayStartMsg";
import SwitchColumnPage from "../pages/SwitchColumnPage";
import FindPage from "../pages/FindPage";
import SkipCondition from "../pages/AddSkipCondition";
import DuplicateEntries from "../pages/DuplicateEntries";
import FormulaPage from "../pages/FormulaPage";
import CreateCustomColumn from "../pages/CreateCustomColumn";
import DateAndCodeCombination from "../pages/DateAndCharacterCodeComb";
import OutputFileSettings from "../pages/OutputFileSettings";
import Aggregate from "../pages/Aggregate";
import MergeColumns from "../pages/MergeColumns";
import CreateColumnPairs from "../pages/CreateColumnPairs";
import InfoDialog from "./InforDialog";
import { infoContent } from "../constants";
import InvoiceNumberConfig from "../pages/InvoiceNumberConfig";

const Configure = () => {
  const selectedAction = useSelector(getSelectedAction);
  const info = infoContent[selectedAction]; // get title/desc from mapping

  return (
    <div className="w-full sm:w-[800px] h-full">
      {selectedAction && headings[selectedAction] && (
        <div className="flex items-center justify-center gap-2 mt-2 mb-6">
          <h1 className="font-bold text-center">{headings[selectedAction]}</h1>
          {info && (
            <InfoDialog title={info.title} description={info.description} />
          )}
        </div>
      )}
      {selectedAction === "Configure" && <DisplayStartMsg />}
      {selectedAction === "find" && <FindPage />}
      {selectedAction === "fileSettings" && <FileSettingPage />}
      {selectedAction === "outputFileSettings" && <OutputFileSettings />}
      {selectedAction === "swt" && <SwitchColumnPage />}
      {selectedAction === "grpby" && <GroupbyFeaturePage />}
      {selectedAction === "addCharacterCodes" && <AddCharactersPage />}
      {/* {selectedAction === "cmb" && <AddCombinationPage />} */}
      {selectedAction === "skipCondition" && <SkipCondition />}
      {selectedAction === "duplicate" && <DuplicateEntries />}
      {selectedAction === "formula" && <FormulaPage />}
      {selectedAction === "CreateCustomColumn" && <CreateCustomColumn />}
      {selectedAction === "DateAndCharacterCodeComb" && (
        <DateAndCodeCombination />
      )}
      {selectedAction === "Aggregate" && <Aggregate />}
      {selectedAction === "mergeColumns" && <MergeColumns />}
      {selectedAction === "sumColumnPairs" && <CreateColumnPairs />}

      {selectedAction === "InvoiceGenerator" && <InvoiceNumberConfig />}
    </div>
  );
};

export default Configure;
